import { useState, useContext, useEffect, useRef } from "react";
import { flushSync } from "react-dom";
import ContactUs from "../../pages/Customer/CustomerRequest/ContactUs";
import HistoricalData from "../../pages/Customer/CustomerRequest/HistoricalData";
import { Navbar, Container, Nav, Dropdown, Image } from "react-bootstrap";

import logo from "../Assests/logo 1.png";
import { getUserPhoto } from "../../../src/services/signInApi"
import { msalInstance } from "../../../src/authConfig";
import defaultUser from "../Assests/user.png";
import { RoleContext } from "../../RoleContext";
import { useNavigate } from "react-router-dom";
import ContactIcon from "../Assests/Icons/Contact.png";
import NotificationBell from "../Assests/Icons/Bell.png";
import History from "../Assests/Icons/History.png";
import { getNotificationListData } from "../../pages/Customer/Notification/NotificationApi";
import { useNotification } from "../../pages/Customer/Notification/NotificationProvider";

const UserDashboardPath = {
  ["Lab Admin"]: "/global-dashboard",
  ["IT Admin"]: "/global-dashboard",
  ["Customer"]: "/customer-dashboard",
  ["Analyst"]: "/analyst-dashboard",
  ["Field Staff"]: "/field-staff-dashboard",
};

const Header = ({ expanded }) => {
  const navigate = useNavigate();
  const { role, setRole, roleOptions, setRoleOptions, name } =
    useContext(RoleContext);
  const [userName, setUserName] = useState("User");
  const [userPhoto, setUserPhoto] = useState(null);
  const { unreadCount, fetchUnreadCount} = useNotification();

  const sideNavWidth = expanded ? 265 : 64;

  // --- Controller properties ---
  const showSwitchUser = ["Lab Admin", "Analyst", "IT Admin"].includes(role);
  const showCustomerIcons = role === "Customer";
  const [showHistoricalModal, setShowHistoricalModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  // --- Notification Dropdown State ---
  const [showNotifDropdown, setShowNotifDropdown] = useState(false);
  const [notifList, setNotifList] = useState([]);
  const [notifCount, setNotifCount] = useState(0);
  const notifDropdownRef = useRef(null);
  const notifBellRef = useRef(null);

  const [adminLocation, setadminLocation] = useState(""); 
  useEffect(() => {
   fetchUnreadCount();
  }, []);

  useEffect(() => {
    const storedlocation = localStorage.getItem("selectedLocationName");
    const storedRole = JSON.parse(localStorage.getItem("currentRole"));
    if (storedlocation && (storedRole == 'Lab Admin' || storedRole == 'Analyst' || storedRole == 'IT Admin')) {
      setadminLocation(storedlocation);
    }
    else{
      setadminLocation('');
    }
  }, []);

  useEffect(() => {
    const loadPhoto = async () => {
      try {
        if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
          msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        }

        const photoUrl = await getUserPhoto();
        if (photoUrl) {
          setUserPhoto(photoUrl);
        } else {
          setUserPhoto(defaultUser);
        }
      } catch (error) {
        console.error("Failed to load user photo:", error);
        setUserPhoto(defaultUser);
      }
    };

    loadPhoto();
  }, []);

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        const fetchedName =
          userData.name ||
          userData.fullName ||
          userData.username ||
          userData.displayName;

        if (fetchedName) {
          setUserName(fetchedName);
        }
      } catch (e) {
        console.error("Error parsing userData:", e);
      }
    }
  }, []);


  useEffect(() => {
    const fetchUnreadNotifications = async () => {
      try {
        const { userID } = JSON.parse(localStorage.getItem("userData")) || {};
        const params = {
          loggedInUserId: userID,
          PageNumber: 1,
          PageSize: 10,
        };
        const res = await getNotificationListData(params);
        const unread = (res.results || []).filter(n => !n.isRead);
        setNotifCount(unread.length);
        if (showNotifDropdown) setNotifList(unread.slice(0, 5));
      } catch {
        setNotifCount(0);
        setNotifList([]);
      }
    };
    fetchUnreadNotifications();
  }, [showNotifDropdown, window.location.pathname]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        notifDropdownRef.current &&
        !notifDropdownRef.current.contains(event.target) &&
        notifBellRef.current &&
        !notifBellRef.current.contains(event.target)
      ) {
        setShowNotifDropdown(false);
      }
    }
    if (showNotifDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showNotifDropdown]);
  const handleSignOut = () => {
    var localUser = localStorage.getItem("userEmail");
    localStorage.clear();
    localStorage.setItem("userEmail",localUser);
    navigate("/");
  };
const handleUserSwitch = (eventKey) => {
  // ProtectedRoute always reads the new role on the very next render.
  flushSync(() => {
    setRole(eventKey);
  });

  // Save new role
  localStorage.setItem("currentRole", JSON.stringify(eventKey));

  if (eventKey !== "Lab Admin" && eventKey !== "Analyst" && eventKey !== "IT Admin") {
    // For all other roles, clear location
    localStorage.removeItem("selectedLocationName");
    setadminLocation("");
  } else {
    // For Lab Admin & Analyst, keep or reload stored location
    if (eventKey === "Analyst") {
      const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        const fetchLocations =
          userData.locations.map(loc => loc.locationName).join(",") || "";
          localStorage.setItem("selectedLocationName", fetchLocations);
      } catch (e) {
        console.error("Error parsing userData:", e);
      }
    }

    }
    const storedLocation = localStorage.getItem("selectedLocationName");
    setadminLocation(storedLocation || "");
  }

  navigate(UserDashboardPath[eventKey], { replace: true });
};


  return (
    <Navbar
      bg="white"
      expand="md"
      fixed="top"
      className="shadow-sm border-bottom"
      style={{ marginLeft: sideNavWidth, transition: "margin-left 0.3s ease" }}
    >
      <Container fluid>
        {/* Left Section: Logo & Title */}
        <Navbar.Brand className="d-flex align-items-center gap-2">
          <Image src={logo} height={32} alt="Logo" />
          <div className="vr mx-2 d-none d-sm-block" />
          <span className="fw-semibold text-dark portal-title">
            Feed Assay Portal {adminLocation && ` (${adminLocation})`}
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="header-navbar" />

        <Navbar.Collapse id="header-navbar" className="justify-content-end">
          <Nav className="align-items-center gap-3 flex-wrap">

            {/* Switch User - Only for Lab Admin & Analyst */}
            {showSwitchUser && (
              <div className="d-flex align-items-center">
                <span className="switch-label me-2 d-none d-sm-block">
                  Switch User
                </span>
                <Dropdown onSelect={handleUserSwitch}>
                  <Dropdown.Toggle
                    variant="light"
                    className="px-3 py-2 border rounded bg-light"
                    style={{ fontSize: "14px", minWidth: "140px" }}
                  >
                    {role}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {roleOptions.map((r) => (
                      <Dropdown.Item eventKey={r} key={r}>
                        {r}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}

            {/* Customer-only Icons */}
            {showCustomerIcons && (
              <>
                <span
                  className="d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowContactModal(true)}
                  title="Contact"
                >
                  <img src={ContactIcon} alt="Contact" style={{ width: 40, height: 40 }} />
                </span>
                <span
                  className="d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowHistoricalModal(true)}
                  title="History"
                >
                  <img src={History} alt="History" style={{ width: 40, height: 40 }} />
                </span>
                <span
                  className="d-flex align-items-center position-relative"
                  style={{ cursor: "pointer" }}
                  ref={notifBellRef}
                  onClick={() => setShowNotifDropdown((v) => !v)}
                  title="Notification"
                >
                  <img src={NotificationBell} alt="Notification" style={{ width: 40, height: 40 }} />
                  {unreadCount > 0 && (
                    <span style={{
                      position: "absolute",
                      top: 2,
                      right: 2,
                      background: "#e13b3b",
                      color: "#fff",
                      borderRadius: "50%",
                      width: 20,
                      height: 20,
                      fontSize: 13,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      zIndex: 2
                    }}>{unreadCount}</span>
                  )}
                  {showNotifDropdown && (
                    <div ref={notifDropdownRef} style={{
                      position: "absolute",
                      top: 48,
                      right: -25,
                      minWidth: 320,
                      background: "#fff",
                      boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
                      borderRadius: 8,
                      zIndex: 100,
                      padding: "8px 0"
                    }}>
                      {notifList.length === 0 ? (
                        <div style={{ padding: "16px", textAlign: "center", color: "#888" }}>No unread Notifications</div>
                      ) : (
                        notifList.map((n, idx) => (
                          <div
                            key={n.notificationId}
                            style={{
                              padding: "12px 20px",
                              borderBottom: idx < notifList.length - 1 ? "1px solid #eee" : "none",
                              fontSize: 15,
                              cursor: "pointer"
                            }}
                            onClick={() => { navigate("/notification"); setShowNotifDropdown(false); }}
                          >
                            <span style={{ fontWeight: 600 }}>{n.message}</span>
                          </div>
                        ))
                      )}
                      <div style={{ padding: "10px 20px", textAlign: "right" }}>
                        <span style={{ color: "#003087", fontWeight: 500, cursor: "pointer" }}
                          onClick={() => { navigate("/notification"); setShowNotifDropdown(false); }}
                        >View all notifications  &rarr;</span>
                      </div>
                    </div>
                  )}
                </span>
              </>
            )}

            {/* User Dropdown - Common for all roles */}
            <Dropdown align="end">
              <Dropdown.Toggle className="d-flex align-items-center p-0 border-0 bg-transparent">
                <span className="user-name d-none d-sm-block fw-medium text-dark me-2">
                  {userName}
                </span>
                <Image src={userPhoto || defaultUser} height={35} width={35} 
                style={{ 
                borderRadius: "50%", 
                objectFit: "cover" 
                }} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleSignOut}>Sign Out</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
      {/* Historical Data Modal */}
      <HistoricalData show={showHistoricalModal} onHide={() => setShowHistoricalModal(false)} />
      {/* Contact Us Modal */}
      <ContactUs show={showContactModal} onHide={() => setShowContactModal(false)} />
    </Navbar>
  );
};

export default Header;
